// Categories explicitly used for paid promotional articles, not ordinary display ads.
const sponsoredCategories = new Set(['advertisement', 'sponsored-content', 'sponsored']);
export function isSponsoredStory(story) {
  return [story?.category, ...(story?.categorySlugs || [])]
    .some(slug => sponsoredCategories.has(String(slug || '').toLowerCase()));
}
